"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFieldWithAction = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var inputs_1 = require("../inputs");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

exports.InputFieldWithAction = utils_2.forwardRef(function InputFieldWithAction(props, ref) {
  var icon = props.icon,
      onClick = props.onClick,
      placeHolder = props.placeHolder,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon;
  var button = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tposition: relative !important;\n\t\twidth: 2.625em;\n\t\theight: 47px;\n\t\tmargin-left: -5px;\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder: none;\n\t\tborder-top-right-radius: 4px;\n\t\tborder-bottom-right-radius: 4px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.1s ease-in-out;\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 0.1s ease-in-out;\n\t\t}\n\t"], ["\n\t\tposition: relative !important;\n\t\twidth: 2.625em;\n\t\theight: 47px;\n\t\tmargin-left: -5px;\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder: none;\n\t\tborder-top-right-radius: 4px;\n\t\tborder-bottom-right-radius: 4px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.1s ease-in-out;\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t\ttransition: all 0.1s ease-in-out;\n\t\t}\n\t"])), foundation_1.colors.secondary.grey, foundation_1.colors.white, foundation_1.colors.secondary.darkGrey);

  var renderAction = function renderAction() {
    return (0, _core.jsx)(lseds_1.lseds.button, {
      css: button,
      onClick: onClick
    }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
      icon: rightIcon || 'chevron-right'
    }));
  };

  return (0, _core.jsx)(inputs_1.InputField, {
    action: renderAction(),
    leftIcon: leftIcon,
    placeHolder: placeHolder
  });
});

if (utils_1.isDev) {
  exports.InputFieldWithAction.displayName = 'InputFieldWithAction';
}

var templateObject_1;